// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"d703dbb8","334":"9422d7af","427":"ed0f8212","434":"c93252e9","453":"59f5a346","604":"c949cf6b","608":"247063bd","665":"632b9aec","903":"6d010863"}[chunkId] + ".chunk.js";
};